import React from 'react';
import Flex from './../../Flex';
import { Button, Progress, Table } from 'antd';
import TitleTop from './../../Assembly/titleTop';
import style from './index.css';
import {getLoginUser,createUuid} from '../../../../../utils/NHCore';
import createHistory from 'history/createHashHistory';
import BarCode from 'react-barcode';
import KzxxFormc from './../../KzxxFormc';

const history = createHistory();

export default class PrintTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            xsxx:this.props.initFormDate,//学生信息
            schoolName:this.props.schoolName,//学校名称
            year:this.props.year,//当前年度
            account:this.props.account,//默认账号
            kzxxInitData: this.props.kzxxInitData,
            // nr:this.props.nr
            nr: [
                {
                    key: 1,
                    row_id: 1,
                    nr: '交验录取通知书'
                },
                {
                    key: 2,
                    row_id: 2,
                    nr: '领取一卡通'
                },
                {
                    key: 3,
                    row_id: 3,
                    nr: '自愿购买保险'
                },
                {
                    key: 4,
                    row_id: 4,
                    nr: '自带床上用品检验'
                },
                {
                    key: 5,
                    row_id: 5,
                    nr: '领取宿舍钥匙'
                },
                {
                    key: 6,
                    row_id: 6,
                    nr: '参加体检'
                },
            ],
        };
    }

    render() {
        const { xsxx, schoolName, year, nr, account,kzxxInitData } = this.state;
        let xqmc = xsxx.xqmc;
        let ldmc = xsxx.ldmc;
        let fjmc = xsxx.fjmc;
        let cwh = xsxx.cwh;
        let nrList = [];//内容list
        if(nr && nr.length>0) {
            nr.map((elem,index)=>{
                nrList.push(
                    <div>
                        <div className={style.ejxybd_label1}>
                            <span>
                            {index+1}
                            </span>
                        </div>
                        <div className={style.ejxybd_label2}>
                            <span>
                            {/* {elem.HJMC} */}
                            {elem.nr}
                            </span>
                        </div>
                    </div>
                    )
                }
            )
        }

        let sfxmList = [];
        if(xsxx.sfxmList) {
            xsxx.sfxmList.map((elem,index)=>{
                sfxmList.push(
                    <div>
                    <div className={style.jfxx_label}>
                        <span>
                        {index+1}
                        </span>
                    </div>
                    <div className={style.jfxx_label}>
                        <span >
                        {elem.sfxmmc}
                        </span>
                    </div>
                    <div className={style.jfxx_label}>
                        <span >
                        {elem.ysje}
                        </span>
                    </div>
                    <div className={style.jfxx_label}>
                        <span >
                        {elem.ssje}
                        </span>
                    </div>
                </div>
                )
            });
        }
        const payColumns = [
            {
                title: '序号',
                dataIndex: 'row_id'
            },
            {
                title: '收费项目',
                dataIndex: 'sfxmmc'
            },
            {
                title: '应收金额',
                dataIndex: 'ysje'
            },
            {
                title: '已交金额',
                dataIndex: 'ssje',
                render: (text, record) => {
                    return <span className="text-primary">{text}</span>;
                }
            }
        ];
        const Columns = [
            {
                title: '序号',
                dataIndex: 'row_id'
            },
            {
                title: '主要内容',
                dataIndex: 'HJMC'
            }
        ];
        return (
                            <div className="box" style={{width:'210mm',margin:'0 auto'}}>
                                <div>
                                    <div style={{textAlign: 'center'}}>
                                        <div  className={style.title} style={{fontSize:'14px'}}>
                                            {schoolName}{year}新生入学报到单
                                        </div>
                                    </div>

                                    <TitleTop title="基本信息" extra={false} />
                                    <Flex className={style.p_sw_big} >
                                        <img className={style.jbxx_icon_bg} src={'api/sm-student/openapi/getStudentPhoto?xsid=' + xsxx.xsid+'&type=10'}/>
                                        <Flex.Item className={style.ml_20} style={{marginLeft:'96px'}}>
                                            {[
                                                {
                                                    label: '姓名',
                                                    name: xsxx.xm
                                                },
                                                {
                                                    label: '性别',
                                                    name: xsxx.xb
                                                },
                                                {
                                                    label: '学号',
                                                    name: xsxx.xh
                                                },
                                                {
                                                    label: '民族',
                                                    name: xsxx.mz
                                                },
                                                {
                                                    label: '政治面貌',
                                                    name: xsxx.zzmm
                                                },
                                                {
                                                    label: '籍贯',
                                                    name: xsxx.jg
                                                },
                                                {
                                                    label: '联系电话',
                                                    name: xsxx.sjhm
                                                },
                                                {
                                                    label: '身份证号',
                                                    name: xsxx.sfzjh
                                                },
                                                {
                                                    label: '考生类型',
                                                    name: xsxx.xslb
                                                },
                                                {
                                                    label: '学院',
                                                    name: xsxx.bmmc
                                                },
                                                {
                                                    label: '专业',
                                                    name: xsxx.zymc
                                                },
                                                {
                                                    label: '班级1',
                                                    name: xsxx.bjmc
                                                }
                                            ].map((elem, index) => {
                                                return (
                                                    <div className={style.jbxx_item} key={index}>
                                                        <span className={style.item_label}>
                                                        {elem.label}：</span>
                                                        <div className={style.item_name_t_clamp_1}>
                                                        {elem.name}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </Flex.Item>
                                    </Flex>
                                    <KzxxFormc ref="refKzxxFormc" 
                                        initData={kzxxInitData}
                                    />
                                    <TitleTop title="宿舍信息" extra={false} />
                                    <div className={style.p_sw_big} style={{padding: '14px 28px', fontSize: '10px'}}>
                                        <div className={style.ssxx_list} style={{border: '1px solid #eaeeed'}}>
                                            {/* <div className={style.ssxx_item}>
                                                <div className={style.ssxx_label} >
                                                    <span>校区：</span>
                                                </div>
                                                <div className={style.ssxx_name} >
                                                    <span>{xqmc}</span>
                                                </div>
                                            </div> */}
                                            <div className={style.ssxx_item}>
                                                <div  className={style.ssxx_label}>
                                                    <span>楼栋：</span>
                                                </div>
                                                <div  className={style.ssxx_name} >
                                                    <span>{ldmc}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={style.ssxx_list} style={{border: '1px solid #eaeeed'}}>
                                            <div className={style.ssxx_item}>
                                                <div className={style.ssxx_label}>
                                                    <span>房间：</span>
                                                </div>
                                                <div className={style.ssxx_name} >
                                                    <span>{fjmc}</span>
                                                </div>
                                            </div>
                                            <div  className={style.ssxx_item} >
                                                <div  className={style.ssxx_label} >
                                                    <span>床位：</span>
                                                </div>
                                                <div className={style.ssxx_name} >
                                                    <span>{cwh}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <TitleTop title="缴费信息" extra={false} />
                                    <div className={style.p_sw_big} >
                                        <div>
                                            <div className={style.jfxx_label}>
                                                <span >
                                                序号
                                                </span>
                                            </div>
                                            <div className={style.jfxx_label}>
                                                <span >
                                                收费项目
                                                </span>
                                            </div>
                                            <div className={style.jfxx_label}>
                                                <span >
                                                应收金额
                                                </span>
                                            </div>
                                            <div className={style.jfxx_label}>
                                                <span >
                                                已交金额
                                                </span>
                                            </div>
                                        </div>
                                        {sfxmList}
                                    </div>
                                    <TitleTop title="二级学院报到" extra={false} />
                                    <div  className={style.p_sw_big}>
                                    <div>
                                        <div className={style.ejxybd_label1}>
                                            <span>
                                            序号
                                            </span>
                                        </div>
                                        <div className={style.ejxybd_label2}>
                                            <span>
                                            主要内容
                                            </span>
                                        </div>
                                    </div>
                                        {nrList}
                                    </div>
                                    <div className={style.p_sw_big}>
                                        <div  style={{position: 'relative'}}>
                                            <div className={style.text_title} style={{ color: '#000',fontSize:'10px'}}>
                                                备注：
                                            </div>
                                            {/* <div className={style.bz_item}>
                                                1.新生拿到报到单后，请到指定地点完成报到流程。
                                            </div>
                                            <div className={style.bz_item}>
                                                2.未缴清费用的同学，需在报到期间缴清费用，如有特殊情况，请到学院迎新点处登记。
                                            </div> */}
                                            <div  className={style.bz_item}>
                                                1.报到单请务必保存好，报到结束后，由学院统一收回。
                                            </div>
                                        </div>
                                        <div style={{}}>
                                        <BarCode
                                        className={style.bz_img}
                                        value={account}
                                        width={2}
                                        height={60}
                                        fontSize={14}
                                        >
                                        </BarCode>
                                        </div>
                                    </div>
                                    </div>
                            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/yxxc/print/Bdd/scjtzyxy/ScjtzyxyPrint.js